import type { ReactNode } from 'react';

export function Eyebrow({ children, dark = false }: { children: ReactNode; dark?: boolean }) {
  return (
    <span
      className={`inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.2em] ${
        dark ? 'text-cream/70' : 'text-clay'
      }`}
    >
      <span className={`h-px w-6 ${dark ? 'bg-cream/50' : 'bg-clay'}`} />
      {children}
    </span>
  );
}
